import * as actions_analytics from 'actions/analytics-actions';
import * as toolbox from 'components/common/toolbox';
import React, { useEffect } from 'react';
import { Ibox } from 'enspire-manager-framework';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

export default function QuotesCard({ startdate, enddate }) {

    const params = useParams();
    const dispatch = useDispatch();

    const analytics = useSelector((store) => store.analytics);
    const quotes = analytics?.analytics_quotes;
    
    useEffect(() => {
        if (startdate && enddate) {
            dispatch(actions_analytics.getQuoteAnalytics(params.handle, params.appId, startdate, enddate));
        }
    }, [startdate, enddate, params.handle]);
 
    return (
        <div className="ibox animated fadeInRight animation-delay-3">
            <Ibox
                className=""
                title={ <h1 className="main-heading heading-quote dashboard align-self-start mx-2">Quotes</h1> }
				show_spinner={ analytics.analytics_quotes_pending }
            >
                <div className="px-2">
                    <h1 className="no-margins">{ toolbox.formatNumber(quotes?.totalApproved ?? 0, 2, true) }</h1>
                    <small>Approved Quotes</small>

                    <hr />

                    <div className="row">
                        <div className="col-4">
                            <small className="stats-label">#&nbsp;Quotes</small>
                            <h4>{ quotes?.count }</h4>
                        </div>
                        <div className="col-4">
                            <small className="stats-label">Accepted</small>
                            <h4>{ quotes?.approved }</h4>
                        </div>
                        <div className="col-4 text-right">
                            <small className="stats-label">$&nbsp;Accepted</small>
                            <h4>{ toolbox.formatPercentage((quotes?.totalApproved ?? 0) / (quotes?.totalCost ?? 1), 2) }</h4>
                        </div>
                    </div>
                </div>
            </Ibox>
        </div>
    );
}